module.exports = __webpack_public_path__ + "static/media/seek-access.a45f515e.png";